import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { on } from '@ember/modifier';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';

export default class SiteHeader extends Component {
  @tracked isMenuOpen = false;

  handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape' && this.isMenuOpen) {
      this.isMenuOpen = false;
      document.removeEventListener('keydown', this.handleKeydown);
    }
  };

  toggleMenu = () => {
    this.isMenuOpen = !this.isMenuOpen;
    if (this.isMenuOpen) {
      document.addEventListener('keydown', this.handleKeydown);
    } else {
      document.removeEventListener('keydown', this.handleKeydown);
    }
  };

  closeMenu = () => {
    this.isMenuOpen = false;
    document.removeEventListener('keydown', this.handleKeydown);
  };

  <template>
    <header class="site-header">
      <div class="container">
        <div class="site-header__inner">
          <LinkTo
            @route="index"
            class="site-logo"
            aria-label="DEVLOED.COM - Home"
          >
            <img
              src="/logo.png"
              alt=""
              class="site-logo__image"
              width="40"
              height="40"
            />
            <span class="site-logo__text">DEVLOED.COM</span>
          </LinkTo>

          <nav class="site-nav" aria-label="Main navigation">
            <button
              type="button"
              class="site-nav__toggle"
              aria-expanded="{{this.isMenuOpen}}"
              aria-controls="main-menu"
              aria-label="{{if this.isMenuOpen 'Close menu' 'Open menu'}}"
              {{on "click" this.toggleMenu}}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                {{#if this.isMenuOpen}}
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                {{else}}
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                {{/if}}
              </svg>
            </button>

            <ul
              id="main-menu"
              class="site-nav__list
                {{if this.isMenuOpen 'site-nav__list--open'}}"
            >
              <li>
                <LinkTo
                  @route="index"
                  class="site-nav__link"
                  @activeClass="site-nav__link--active"
                  {{on "click" this.closeMenu}}
                >
                  {{t "navigation.home"}}
                </LinkTo>
              </li>
              <li>
                <LinkTo
                  @route="services"
                  class="site-nav__link"
                  @activeClass="site-nav__link--active"
                  {{on "click" this.closeMenu}}
                >
                  {{t "navigation.services"}}
                </LinkTo>
              </li>
              <li>
                <LinkTo
                  @route="experience"
                  class="site-nav__link"
                  @activeClass="site-nav__link--active"
                  {{on "click" this.closeMenu}}
                >
                  {{t "navigation.experience"}}
                </LinkTo>
              </li>
              <li>
                <LinkTo
                  @route="publications"
                  class="site-nav__link"
                  @activeClass="site-nav__link--active"
                  {{on "click" this.closeMenu}}
                >
                  {{t "navigation.publications"}}
                </LinkTo>
              </li>
              <li>
                <LinkTo
                  @route="contact"
                  class="site-nav__link"
                  @activeClass="site-nav__link--active"
                  {{on "click" this.closeMenu}}
                >
                  {{t "navigation.contact"}}
                </LinkTo>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  </template>
}
